import { useTheme, useMediaQuery } from '@mui/material';
import DashboardAdminDesktop from './DashboardAdminDesktop';
import DashboardAdminMobile from './DashboardAdminMobile';

export default function DashboardAdminPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <DashboardAdminMobile />
    : <DashboardAdminDesktop />;
}